export const TIMESHEET_GOTO_WEEK = 'TIMESHEET_GOTO_WEEK'
export const TIMESHEET_SELECT_USER = 'TIMESHEET_SELECT_USER'
export const TIMESHEET_RESET_STATE = 'TIMESHEET_RESET_STATE'

export const CLEAR_TOASTS = 'ui/CLEAR_TOASTS'
export const ENQUEUE_TOAST = 'ui/ENQUEUE_TOAST'